import { number, object, string } from 'yup'
import { countries } from '../constants'
import { ports } from '../constants/ports'
import { tel } from './common.schema'

const countryIds = countries.map((c) => c.id)
const portIds = ports.map((p) => p.id)

export const destinationSchema = object({
  consignee: object({
    companyName: string().required(),
    name: string().required(),
    email: string().email().required(),
    tel: tel().required(),
    fax: tel(),
    countryId: number().oneOf(countryIds).required(),
    address1: string().required(),
    address2: string(),
    crnNo: string().required(),
    portOfDischargeId: number().oneOf(portIds),
    finalDestinationId: number().oneOf(portIds),
  }),
  notifyParty: object({
    companyName: string().required(),
    name: string().required(),
    email: string().email().required(),
    tel: tel().required(),
    fax: tel(),
    countryId: number().oneOf(countryIds).required(),
    address1: string().required(),
    address2: string(),
    crnNo: string().required(),
  }),
})
